import { Component, OnInit, Input } from '@angular/core';
import { CommonServiceLayerService, RequestPayLoadFormat } from '../../services/common-service-layer.service';
import { AlertService } from '../../shared/alert.service';
import { SessionhandlerService } from '../../services/sessionhandler.service';
import { SharedService } from '../shared.service';
import { Config } from '../../config/config';
import { domToImage } from 'dom-to-image';
import { JqueryUtilitiesService } from '../utilities/jquery-utilities.service';
import { LayoutService } from '../../layout/layout.service';
import { AppService, DomainDetails } from 'src/app/app.service';
import { environment } from 'src/environments/environment';
import * as jsPDF from 'jspdf';

declare var require: any;

@Component({
  selector: 'app-printer',
  templateUrl: './printer.component.html',
  styleUrls: ['./printer.component.scss']
})
export class PrinterComponent implements OnInit {
  @Input() tableData;
  @Input() id;
  @Input() buttons;
  @Input() printDivInfo;
  @Input() metaData;
  @Input() hideButtonLabels;
  @Input() excelTableData;
  buttonInfo = {
    print: { icon: 'fa-file-o', title: 'Print' },
    excel: { icon: 'fa-file-excel-o', title: 'Excel' },
    pdf: { icon: 'fa-file-pdf-o', title: 'PDF' },
    csv: { icon: 'fa fa-file', title: 'CSV' },
    word: { icon: 'fa fa-file-word-o', title: 'Word' },
    html: { icon: 'fa fa-file-code-o', title: 'HTML' },
    image: {
      icon: '', title: 'Image',
      types: [{ value: 'png', label: 'png' }, { value: 'jpeg', label: 'jpeg' }, { value: 'excel', label: 'Excel' }]
    },
    imageWithoutExcel: {
      icon: '', title: 'Image',
      types: [{ value: 'png', label: 'png' }, { value: 'jpeg', label: 'jpeg' }]
    }
  };
  public tableExcelData: any;
  public encodedImage: any;
  public filtersData: any = {};
  public fields: any;
  public imageLoader = true;
  public GLensLogo: any = Config.GLENS_IMAGE;
  public FujerahLogo: any = Config.FUJERAH_IMAGE;
  public domainDetails: DomainDetails;
  public reportLabel;
  public imageURL;

  constructor(
    public http: CommonServiceLayerService,
    public alert: AlertService,
    public sessionService: SessionhandlerService,
    public shared: SharedService,
    public jQueryUtility: JqueryUtilitiesService,
    public layoutService: LayoutService,
    public appService: AppService
  ) { }
  ngOnInit() {
    this.domainDetails = this.appService.DOMAIN_DETAILS();
    // Config.logger(this.tableData);
    this.buttonInfo = {
      print: { icon: 'fa-file-o', title: 'Print' },
      excel: { icon: 'fa-file-excel-o', title: 'Excel' },
      pdf: { icon: 'fa-file-pdf-o', title: 'PDF' },
      csv: { icon: 'fa fa-file', title: 'CSV' },
      word: { icon: 'fa fa-file-word-o', title: 'Word' },
      html: { icon: 'fa fa-file-code-o', title: 'HTML' },
      image: {
        icon: '', title: 'Exports',
        types: [{ value: 'png', label: 'PNG' },
        { value: 'jpeg', label: 'JPG' }, { value: 'excel', label: 'Excel' }, { value: 'print', label: 'PDF' }]
      },
      imageWithoutExcel: {
        icon: '', title: 'Exports',
        types: [{ value: 'png', label: 'png' }, { value: 'jpeg', label: 'jpeg' }]
      }
    };
    // if (this.metaData && this.metaData.isDropDown) {
    //   this.buttonInfo.image.types.push({ value: 'print', label: 'Print' });
    // }
    this.getAppliedFiltersData();
    this.metaData = Object.assign(this.metaData || {});
    /**
     * While image export or print if it is India we need to have Site Name else Station Name
     */
    this.reportLabel = this.domainDetails.labelType || 'Station Name';
  }
  triggerEvent(type) {
    if (this.metaData.multipleHeaders || this.id) {
      this.exportTable(type);
    } else {
      this[type]();
    }
  }
  printImage(img) {
    this.resetImageContent();
    this.imageLoader = false;
    const DTI = require('dom-to-image');
    let date;
    if (this.filtersData.date) {
      date = this.shared.formatFromAndToDates(this.filtersData.date);
    } else if (this.metaData && this.metaData.headerContent && this.metaData.headerContent.startTime
      && this.metaData.headerContent.endTime) {
      date = { fromDate: this.metaData.headerContent.startTime, toDate: this.metaData.headerContent.endTime };
    } else {
      date = this.shared.formatFromAndToDates([new Date(), new Date()]);
    }
    if (!this.filtersData.station && this.metaData.headerContent && this.metaData.headerContent.siteName) {
      this.filtersData.station = this.metaData.headerContent.siteName;
    }
    if (this.metaData.reportName === 'Remote Calibration') {
      date = { fromDate: this.metaData.headerContent.calibStartTime, toDate: this.metaData.headerContent.calibEndTime }
    }
    const imageMapping = { png: 'toPng', jpeg: 'toJpeg' };
    const imageDivHeader = `
    <div class = "col-md-12 row" style="border-bottom: 1px solid #000;">
        <div class= "col-md-1">
          <img src="assets/images/${this.domainDetails.vendorLogo || ''}" style = "width: 100%;" >
        </div>
        <div class="col-md-10" style = "text-align: center;font-size:18px;">
           <h5 style="color:#000;"> ${this.getStationNameOnImage()} </h5>
           <div style="color:#000;"> Report : ${this.metaData.reportName || ''} </div>
           <div style="color:#000;">Time Range: ${date.fromDate || ''} - ${date.toDate || ''} </div>
           <div style="color:#000;"> ${this.getDisplayStation()} </div>
           <div style="color:#000;"> ${this.getDisplayParameter()} </div>
           <div style="color:#000;"> ${this.getShiftType()} </div>
           <div style="color:#000;"> ${this.getWindSpeed()} </div>
      </div>
      <div class= "col-md-1" >
        <img src="assets/images/${this.domainDetails.clientLogo || ''}" style = "width: 100%;" >
      </div>
    </div>`;
    const id: any = document.getElementById(this.printDivInfo.imageId);
    let imageDuplicate;
    if (this.printDivInfo.echart) {
      imageDuplicate = this.cloneCanvas(id.firstChild.firstElementChild);
    } else {
      imageDuplicate = id.cloneNode(true);
    }
    if (this.metaData.reportName === 'Data Validation') {
      imageDuplicate.style.marginTop = 0;
      imageDuplicate.style.textAlign = 'center';
    }
    document.getElementById('downloadImageDiv').appendChild(imageDuplicate);
    document.getElementById('imageHeaderDiv').innerHTML = imageDivHeader;
    const imageDiv = document.getElementById('headerDownloadImageDiv');
    if (img.value === 'excel') {
      setTimeout(() => {
        DTI.toPng(imageDiv, { quality: 0.95 })
          .then(dataUrl => {
            this.createImageExcel(dataUrl);
          });
      }, 3000);
    } else if (img.value === 'print') {
      if (this.appService.DOMAIN_DETAILS().electron) {
        setTimeout(() => {
          // tslint:disable-next-line:no-string-literal
          DTI[imageMapping['png']](imageDiv, { quality: 0.95 })
            .then(dataUrl => {
              this.createImage(dataUrl, 'png', 'print');
            });
        }, 3000);
      } else {
        this.print();
      }
    } else {
      setTimeout(() => {
        DTI[imageMapping[img.value]](imageDiv, { quality: 0.95 })
          .then(dataUrl => {
            this.createImage(dataUrl, img.value, 'image');
          });
      }, 3000);
    }
  }
  getStationNameOnImage() {
    if (this.metaData.siteName || this.filtersData.station) {
      return `${this.reportLabel} : ${this.metaData.siteName || this.filtersData.station || ''}`;
    } else {
      return '';
    }
  }
  getShiftType() {
    if (this.metaData && this.metaData.headerContent && this.metaData.headerContent.shift && this.metaData.headerContent.ReportType !== "Fortnight Report") {
      return `Shift Type : ${this.metaData.headerContent.shift}`;
    } else {
      return '';
    }
  }
  getWindSpeed() {
    try {
      if (this.metaData && this.metaData.headerContent && this.metaData.headerContent.AvgSpeed) {
        return `Average Wind Speed : ${this.metaData.headerContent.AvgSpeed} Average Wind Direction : ${this.metaData.headerContent.AvgDirection} Calm : ${this.metaData.headerContent.calmWindSpeed} Blowing From : ${this.metaData.headerContent.blowingFrom}`;
      } else {
        return '';
      }
    } catch (error) {
      console.log(error);
    }
  }
  createImage(dataUrl, extension, value) {
    if (value === 'print') {
      if (this.printDivInfo.id.startsWith('windroseReportImg_')) {
        const doc = new jsPDF('p', 'px', [500, 500]);
        const width = doc.internal.pageSize.getWidth();
        const height = doc.internal.pageSize.getHeight();
        doc.addImage(dataUrl, 'png', 10, 10, width - 10, height - 10);
        // doc.save(this.printDivInfo.imageName + new Date().getTime() + '.pdf');
        doc.save(this.printDivInfo.imageName + '.pdf');
        this.imageLoader = true;
      } else {
        const doc = new jsPDF({ orientation: 'landscape' });
        const width = doc.internal.pageSize.getWidth();
        const height = doc.internal.pageSize.getHeight();
        doc.addImage(dataUrl, 'png', 10, 10, width - 10, height - 10);
        // doc.save(this.printDivInfo.imageName + new Date().getTime() + '.pdf');
        doc.save(this.printDivInfo.imageName + '.pdf');
        this.imageLoader = true;
      }
    } else {
      const link = document.createElement('a');
      // link.download = this.printDivInfo.imageName + new Date().getTime() + `.${extension}`;
      link.download = this.printDivInfo.imageName + `.${extension}`;

      link.href = dataUrl;
      link.click();
      this.imageLoader = true;
    }
  }
  resetImageContent() {
    document.getElementById('headerDownloadImageDiv').innerHTML = `
    <div id="imageHeaderDiv" style="background-color:#fff;"></div>
    <div id="downloadImageDiv">
    </div>
    `;
  }
  createImageExcel(dataUrl) {
    dataUrl = dataUrl.split(',');
    if (this.tableData) {
      this.metaData.headerLabel = 'key';
      this.tableExcelData = this.getPayLoad();
    } else {
      this.tableExcelData = {
        dataExcel: '.*.*.*.*.*.*.',
        headerContent: {
          ReportName: this.metaData.reportName,
          ReportType: this.metaData.reportName
        },
        dataDelimiter: '*'
      };
    }
    if (this.metaData.headerContent) {
      this.tableExcelData.headerContent = Object.assign(this.tableExcelData.headerContent, this.metaData.headerContent);
    }
    this.tableExcelData.imageUpload = dataUrl[1];
    try {
      this.imageLoader = true;
      const request: RequestPayLoadFormat = {
        api: 'ExcelDump', // excelDump
        method: 'postText',
        loader: true,
        type: 'API',
        hideErrorMessage: false,
        payLoad: this.tableExcelData
      };
      this.http.API_REQUEST(request).subscribe(response => {
        try {
          if (response && response.name) {
            // window.open(Config.API.download + '?name=' + response.name);
            // this.shared.downloader(Config.API.download + '?name=' + response.name);
            this.shared.downloader(Config.API.download + '?name=' + response.name + '&' + new Date().getTime());
          } else {
            this.alert.open('error', 'Failed to download, please try again', '');
          }
        } catch (error) {
          this.shared.dataNotFoundMsg(error);
          Config.logger(error);
        }
      }
      );
    } catch (error) {
      Config.logger(error);
      this.shared.internalCodeError(error);
    }
  }
  print() {
    // Create document with current html head and set metadata, then open the doc in new tab and print the same
    const id: any = document.getElementById(this.printDivInfo.id);
    let date = this.shared.formatFromAndToDates(this.filtersData.date);
    if (this.metaData && this.metaData.headerContent && this.metaData.headerContent.startTime
      && this.metaData.headerContent.endTime) {
      date = { fromDate: this.metaData.headerContent.startTime, toDate: this.metaData.headerContent.endTime };
    }
    let divContent;
    if (this.printDivInfo.canvas) {
      divContent = `<img src = "${id.toDataURL()}"/>`;
    } else if (this.printDivInfo.echart) {
      divContent = `<img src = "${id.firstChild.firstElementChild.toDataURL()}"/>`;
    } else {
      divContent = id.innerHTML;
    }
    const template = `
    <!DOCTYPE html>
      <html>
        <head>
          <title>${this.metaData.reportName}</title>
          <style>
          .col-print-1 {width:8%;  float:left;}
          .col-print-2 {width:16%; float:left;}
          .col-print-3 {width:25%; float:left;}
          .col-print-4 {width:33%; float:left;}
          .col-print-5 {width:42%; float:left;}
          .col-print-6 {width:50%; float:left;}
          .col-print-7 {width:58%; float:left;}
          .col-print-8 {width:66%; float:left;}
          .col-print-9 {width:75%; float:left;}
          .col-print-10{width:83%; float:left;}
          .col-print-11{width:92%; float:left;}
          .col-print-12{width:100%; float:left;}
          .center-text{
            text-align: center;
          }
          .printHeaderCSS{
            border-bottom: 1px solid #000;
          }
          .input-container{
            display: none;
          }
          app-printer {
            display: none;
          }
          .c3 path, .c3 line {
            fill: none;
            stroke: #000; }
            .chart-printer-logo{
              width: 7em;
            }
          .c3-axis {font-weight:bold; color:#000;}
          </style>
          <link rel="stylesheet" href="assets/css/printer-stylings.css" media="print">
          <link rel="stylesheet" href="assets/css/c3.css" media="print">
          <link rel="stylesheet" href="assets/css/bootstrap.min.css" media="print">
        </head>
          <body>
          <div class="row printHeaderCSS">
            <div class= "col-print-1" style="border-bottom: 1px solid #000;">
            <img src="assets/images/${this.domainDetails.vendorLogo || ''}" style = "width: 100%;" >
            </div>
            <div class = "col-print-10 center-text">
              <h2> ${this.metaData.reportName} </h2>
              <div> ${this.getStationNameOnImage()}</div>
              <div>From Date: ${date.fromDate ? date.fromDate : ''}, To Date: ${date.toDate ? date.toDate : ''} </div>
            </div>
            <div class= "col-print-1">
              <img src="assets/images/${this.domainDetails.clientLogo || ''}" style = "width: 100%;">
            </div>
          </div>
          <div class="row">
            <div class="col-print-12">
               ${divContent}
            </div>
          </div>
          </body>
      </html>
    `;
    setTimeout(() => {
      const win = window.open(`${this.metaData.reportName || 'print_chart'}.html`, '_blank');
      win.focus();
      win.document.write(template);
      this.printWindow(win);
    }, 500);

  }
  printWindow(win) {
    try {
      setTimeout(() => {
        win.stop();
        win.print();
        win.close();
        this.imageLoader = true;
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  }
  tableContentInString(delimiter, type?, customTableData?) {
    let CSV = '';
    let tableData;
    if (type === 'excel' && this.excelTableData) {
      tableData = this.excelTableData;
    } else if (customTableData) {
      tableData = customTableData;
    } else {
      tableData = this.tableData;
    }
    const headers = tableData.headerContent.filter(ele => !(ele.hidden || ele.refKey));
    headers.forEach((element, index) => {
      let header = (element[this.metaData.headerLabel || 'name']);
      if (typeof header !== 'string') {
        header = JSON.stringify(header);
      } else {
        console.log(type)
        if (header.length > 30 && type==='pdf') {
            header = header.slice(0, 30) + "<br>" + header.slice(30);
          // header = header.toString().replace(/(.{30})/g, '$1<br>');
        } else {
          header = header;
        }
      }
      // header = (typeof header !== 'string') ? JSON.stringify(header) : header;
      CSV += (header || ' ').replace(/,|\n/g, ' ') +
        (index === headers.length - 1 ? '' : delimiter);
    });
    CSV += '\n';
    tableData.bodyContent.forEach(row => {
      headers.forEach((col, index) => {
        let value = (row[col[this.metaData.headerKey] || col.key]);
        if (value || value === 0) {
          // if ((col[this.metaData.headerKey] || col.key === 'StationName' || col.label === 'Station Name') && value.length > 30 && this.domainDetails.isYIL && type === 'pdf') {
          if ((col[this.metaData.headerKey] || col.key) && value.length > 30 && this.domainDetails.isBPCL && type === 'pdf') {
            value = value.slice(0, 30) + "<br>" + value.slice(30);
            // value = value.toString().replace(/(.{30})/g, '$1<br>');
          } else {
            value = value.toString();
          }
        } else {
          value = '';
        }
        CSV += ((!value && value !== 0) ? ' ' : value).replace(/,|\n/g, ' ')
          + (index === headers.length - 1 ? '' : delimiter);
      });
      CSV += '\n';
    });
    CSV = this.removeInvalidCharacters(CSV);
    return CSV;
  }
  removeInvalidCharacters(data) {
    const splCharacters = [{ key: '°', value: 'degree ' }];
    let regEx;
    splCharacters.forEach(ele => {
      regEx = new RegExp(ele.key, 'g');
      data = data.replace(regEx, ele.value);
    });
    return data;
  }
  csv() {
    const payLoad = this.getPayLoad();
    try {
      const request: RequestPayLoadFormat = {
        api: 'CsvDump',
        method: 'postText',
        loader: true,
        type: 'API',
        hideErrorMessage: false,
        payLoad
      };
      this.http.API_REQUEST(request).subscribe(response => {
        try {
          if (response && response.name) {
            // window.open(Config.API.download + '?name=' + response.name);
            // this.shared.downloader(Config.API.download + '?name=' + response.name);
            this.shared.downloader(Config.API.download + '?name=' + response.name + '&' + new Date().getTime());
          } else {
            // this.csvBackupDownload();
            this.alert.open('error', 'Failed to download, please try again', '');
          }
        } catch (error) {
          this.shared.dataNotFoundMsg(error);
          Config.logger(error);
        }
      }
      );
    } catch (error) {
      Config.logger(error);
      this.shared.internalCodeError(error);
    }
  }
  csvBackupDownload() {
    const uri = 'data:text/csv;charset=utf-8,' + escape(this.tableContentInString(','));
    const link: any = document.createElement('a');
    link.href = uri;
    link.style = 'visibility:hidden';
    link.download = this.metaData.headerContent.ReportName + '.csv';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  getPayLoad(type?) {
    let data: any = {};
    try {
      data = {
        headerContent: this.metaData.headerContent || { ReportName: this.metaData.fileName, ReportType: this.metaData.fileName },
        fileName: this.metaData.fileName,
        reportName: this.metaData.fileName,
        user: this.sessionService.api.session.get(this.appService.constants.userName),
        userId: this.sessionService.api.session.get(this.appService.constants.userId),
        siteName: this.metaData.siteName,
        dataDelimiter: '*',
        headerColors: this.metaData.printMetaData ? this.metaData.printMetaData.headerColors : []
      };
      if (this.metaData.headerContent.ReportType === 'Fortnight Report' && this.metaData.headerContent.stationName) {
        data.headerContent['displayStation'] = this.metaData.headerContent.stationName;
      }
      if (this.tableData.bindTable) {
        if (this.tableData.tableData1 && this.tableData.tableData2) {
          data.dataExcel1 = this.tableContentInString('*', type, this.tableData.tableData1);
          data.dataExcel = this.tableContentInString('*', type, this.tableData.tableData2);
        } else if (this.tableData && this.tableData.printTableData) {
          data.dataExcel1 = this.tableContentInString('*', type, this.tableData);
          data.dataExcel = this.tableContentInString('*', type, this.tableData.printTableData);
        }
      } else {
        data.dataExcel = this.tableContentInString('*', type);
      }
    } catch (error) {
      console.log(error);
    }
    return data;
  }
  wordGetPayLoad() {
    return {
      dataExcel: this.tableContentInString('*'),
      headerContent: this.metaData.headerContent,
      fileName: this.metaData.fileName,
      siteName: this.metaData.siteName,
    };
  }
  exportTable(type) {
    const payLoad = {
      dataExcel: this.jQueryUtility.multipleHeaderTableString(this.metaData, '*', undefined, this.id),
      dataDelimiter: '*',
      reportName: this.metaData.fileName,
      user: this.sessionService.api.session.get(this.appService.constants.userName),
      userId: this.sessionService.api.session.get(this.appService.constants.userId),
      fileName: this.metaData.fileName ? (this.metaData.fileName.replace(/ /gi, '') + '.' + type) : ('report.' + type),
      headerContent: this.metaData.headerContent ? this.metaData.headerContent : {
        ReportName: this.metaData.fileName,
        ReportType: this.metaData.fileName
      },
      siteName: this.metaData.siteName
    };
    try {
      const api = this.appService.constants.reports[type];
      const request: RequestPayLoadFormat = {
        api,
        method: 'postText',
        loader: true,
        type: 'API',
        hideErrorMessage: false,
        payLoad
      };
      this.http.API_REQUEST(request).subscribe(response => {
        try {
          if (response && response.name) {
            // window.open(Config.API.download + '?name=' + response.name);
            // this.shared.downloader(Config.API.download + '?name=' + response.name);
            this.shared.downloader(Config.API.download + '?name=' + response.name + '&' + new Date().getTime());
          } else {
            // this.csv();
            this.alert.open('error', 'Failed to download, please try again', '');
          }
        } catch (error) {
          this.shared.dataNotFoundMsg(error);
          Config.logger(error);
        }
      }
      );
    } catch (error) {
      Config.logger(error);
      this.shared.internalCodeError(error);
    }
  }
  excel() {
    try {
      const payLoad = this.getPayLoad('excel');
      const request: RequestPayLoadFormat = {
        api: 'ExcelDump',
        method: 'postText',
        loader: true,
        type: 'API',
        hideErrorMessage: false,
        payLoad
      };
      this.http.API_REQUEST(request).subscribe(response => {
        try {
          if (response && response.name) {
            // window.open(Config.API.download + '?name=' + response.name);
            // this.electronService.shell.openItem(Config.API.download + '?name=' + response.name);
            // this.shared.downloader(Config.API.download + '?name=' + response.name);
            this.shared.downloader(Config.API.download + '?name=' + response.name + '&' + new Date().getTime());
          } else {
            // this.csv();
            this.alert.open('error', 'Failed to download, please try again', '');
          }
        } catch (error) {
          this.shared.dataNotFoundMsg(error);
          Config.logger(error);
        }
      });
    } catch (error) {
      Config.logger(error);
      this.shared.internalCodeError(error);
    }
  }
  pdf() {
    let payLoad;
    if (this.domainDetails.isYIL) {
      payLoad = this.getPayLoad('pdf');
    } else {
      payLoad = this.getPayLoad();
    }
    try {
      const request: RequestPayLoadFormat = {
        api: 'PdfDump',
        method: 'postText',
        loader: true,
        type: 'API',
        hideErrorMessage: false,
        payLoad
      };
      this.http.API_REQUEST(request).subscribe(response => {
        try {
          if (response && response.name) {
            // window.open(Config.API.pdfUrl + `?name=${response.name}`);
            // window.open(Config.API.download + '?name=' + response.name);
            // console.log(Math.floor(Math.random()*100));
            // this.shared.downloader(Config.API.download + '?name=' + response.name);
            this.shared.downloader(Config.API.download + '?name=' + response.name + '&' + new Date().getTime());
          } else {
            this.alert.open('error', 'Failed to download, please try again', '');
          }
        } catch (error) {
          this.shared.dataNotFoundMsg(error);
          Config.logger(error);
        }
      }
      );
    } catch (error) {
      Config.logger(error);
      this.shared.internalCodeError(error);
    }
  }
  html() {
    const payLoad: any = this.wordGetPayLoad();
    payLoad.dataDelimiter = '*';
    payLoad.reportName = payLoad.headerContent.ReportType;
    try {
      const request: RequestPayLoadFormat = {
        api: 'HTMLDump', // excelDump
        method: 'postText',
        loader: true,
        type: 'API',
        hideErrorMessage: false,
        payLoad
      };
      this.http.API_REQUEST(request).subscribe(response => {
        try {
          if (response && response.name) {
            // window.open(Config.API + `?name=${response.name}`);
            // window.open(Config.API.download + '?name=' + response.name);
            // this.shared.downloader(Config.API.download + '?name=' + response.name);
            this.shared.downloader(Config.API.download + '?name=' + response.name + '&' + new Date().getTime());
          } else {
            // this.csv();
            this.alert.open('error', 'Failed to download, please try again', '');
          }
        } catch (error) {
          this.shared.dataNotFoundMsg(error);
          Config.logger(error);
        }
      }
      );
    } catch (error) {
      Config.logger(error);
      this.shared.internalCodeError(error);
    }
  }
  word() {
    const payLoad: any = this.wordGetPayLoad();
    payLoad.dataDelimiter = '*';
    payLoad.reportName = payLoad.headerContent;
    payLoad.version = ' v7.0';
    try {
      const request: RequestPayLoadFormat = {
        api: 'WordDump', // excelDump
        method: 'postText',
        loader: true,
        type: 'API',
        hideErrorMessage: false,
        payLoad
      };
      this.http.API_REQUEST(request).subscribe(response => {
        try {
          if (response && response.name) {
            // window.open(Config.API + `?name=${response.name}`);
            // window.open(Config.API.download + '?name=' + response.name);
            // this.shared.downloader(Config.API.download + '?name=' + response.name);
            this.shared.downloader(Config.API.download + '?name=' + response.name + '&' + new Date().getTime());
          } else {
            // this.csv();
            this.alert.open('error', 'Failed to download, please try again', '');
          }
        } catch (error) {
          this.shared.dataNotFoundMsg(error);
          Config.logger(error);
        }
      }
      );
    } catch (error) {
      Config.logger(error);
      this.shared.internalCodeError(error);
    }
  }
  /**
   * Get applied filters data
   */
  getAppliedFiltersData() {
    try {
      this.layoutService.getFiltersData().subscribe(response => {
        this.onFiltersChange(response);
      });
    } catch (error) {
      Config.logger(error);
    }
  }
  onFiltersChange(serviceData) {
    try {
      const fields = serviceData.fields.filter(ele => !ele.hidden);
      const savedDataKeys = Object.keys(serviceData.data);
      const labels = [];
      let index;
      savedDataKeys.forEach(key => {
        index = fields.findIndex(ele => ele.key === key);
        if (index > -1) {
          const labelMappings = ['select', 'multiselect'];
          const obj = { value: serviceData.data[key], field: fields[index] };
          if (labelMappings.indexOf(fields[index].type) > -1) {
            // apply logic for multiselect here
            if (fields[index].type === 'multiselect') {
              obj.value = [];
              serviceData.data[key].forEach((val, i) => {
                obj.value.push(this.bindValueToObj(fields, index, serviceData, key, i));
              });
            } else {
              obj.value = this.bindValueToObj(fields, index, serviceData, key);
            }
          }
          labels.push(obj);
        }
      });
      this.fields = labels;
      this.fields.forEach(element => {
        this.filtersData[element.field.key] = element.value;
      });
      // Config.logger('Filters applied: ', this.fields);
      // Config.logger('Copied Filters applied: ', this.filtersData);
    } catch (error) {
      Config.logger(error);
    }
  }
  bindValueToObj(fields, index, serviceData, key, i?) {
    let value = '';
    try {
      if (typeof (fields[index].options[0]) === 'object') {
        const labelIndex = fields[index].options.findIndex(opt =>
          opt[fields[index].bindValue || 'key'] === (i !== undefined ? serviceData.data[key][i] : serviceData.data[key]));
        if (labelIndex > -1 && fields[index].options[labelIndex]) {
          value = fields[index].options[labelIndex][fields[index].bindLabel || ''];
        }
      }
    } catch (error) {
      Config.logger(error);
    }
    return value;
  }
  cloneCanvas(oldCanvas) {
    const newCanvas = document.createElement('canvas');
    const context = newCanvas.getContext('2d');
    newCanvas.width = oldCanvas.width;
    newCanvas.height = oldCanvas.height;
    context.drawImage(oldCanvas, 0, 0);
    return newCanvas;
  }
  getDisplayStation() {
    try {
      if (this.metaData && this.metaData.headerContent && this.metaData.headerContent.displayStation) {
        return `Station Name : ${this.metaData.headerContent.displayStation}`;
      } else {
        return '';
      }
    } catch (error) {
      console.log(error);
    }
  }
  getDisplayParameter() {
    try {
      if (this.metaData && this.metaData.headerContent && this.metaData.headerContent.displayParameter) {
        return `Parameter : ${this.metaData.headerContent.displayParameter}`;
      } else {
        return '';
      }
    } catch (error) {
      console.log(error);
    }
  }
}
